import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import LoadCSSforfirstTime from "../../../../CloudStorage/LoadCSSforfirstTime";
import CloudStorage from "../../../../CloudStorage/CloudStorage";
import AllAuctionListing from "./AuctionDetails/AllAuctionListing";
import FilterAll from "../FilterAll/FilterAll";
import { getFilter } from "../../../../redux/filter/action";
import { useDispatch, useSelector } from "react-redux";
import OTSSearch from "../../../Common/Search/OTSSearch";
import { useAllFilterBaseContext } from "../../../../Context/AllFilterBaseContext";
import { useRouteBaseStateContext } from "../../../../Context/RouteBaseStateContext";
import { getPostStingName } from "../../../../assests/extention/commonfunction";

export default function SearchAuction() {
  const { setOTSroute } = useRouteBaseStateContext();
  const { state, setSearch } = useAllFilterBaseContext();
  const laung = localStorage.getItem("laung");
  const path = "Assets/scss/FindWork.module.scss";
  const [lan, setLan] = useState(laung ?? "en");
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState('allContests');
  const getallaction = useSelector(({ auction: { getfilterdaction } }) => getfilterdaction);

  useEffect(() => {
    LoadCSSforfirstTime(path);
  }, [path]);

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getFilter(6));
  }, [dispatch]);


  return (
    <div className="project-section searchbuy searchauction">
      <div className="col-md-12 project1 pb-5">
        <div className="col-md-6 mx-auto welcome-sec">
          {/* <h6>👋 Unveiling Treasures: Welcome to Our Exclusive Buy & Sell with Auction (BSA)!</h6> */}
          <h2 className="font-42">Find great items and place your bid</h2>
          <div className="search-bar">
            <OTSSearch
              state={state}
              setSearch={setSearch}
              placeholder={`Search ${getPostStingName("7")}`}
            />
          </div>
          <p>Have a product for auction? Let’s get it listed</p>
          <button
            onClick={() => { navigate(`/${lan}/dashboard/myotsproducts`); setOTSroute('Auctionitem'); }}
            className="btn post-btn"
          >
            Add a Product
            <img
              src={`${CloudStorage.cloudurl}/Assets/Images/project/plus.svg`}
              alt=""
            />
          </button>
        </div>
      </div>
      <div className="col-lg-10 mx-auto tab-sec">
        <ul className="nav nav-tabs">
          <li className="nav-item">
            <a
              className={`nav-link ${activeTab == 'allContests' ? 'active' : ''}`}
              onClick={() => setActiveTab('allContests')}
            >
              All Buy & Sell with Auction (BSA) ({getallaction?.count?.count || 0})
            </a>
          </li>
          <li className="nav-item">
            <a
              className={`nav-link ${activeTab == 'recentlyViewed' ? 'active' : ''}`}
              onClick={() => setActiveTab('recentlyViewed')}
            >
              Recently Viewed ({getallaction?.count?.viewed_count || 0})
            </a>
          </li>
          <li className="nav-item">
            <a
              className={`nav-link ${activeTab == 'savedContests' ? 'active' : ''}`}
              onClick={() => setActiveTab('savedContests')}
            >
              Saved ({getallaction?.count?.wishlist_count || 0})
            </a>
          </li>
          <li className="nav-item">
            <a
              className={`nav-link ${activeTab == 'myBids' ? 'active' : ''}`}
              onClick={() => setActiveTab('myBids')}
            >
              My Bids ({getallaction?.count?.proposed_count || 0})
            </a>
          </li>
        </ul>

        <div className="tab-content">
          {activeTab == 'allContests' && (
            <div className="tab-pane active" id="allcontest">
              <div className="row">
                <div className="col-lg-3 col-md-4">
                  <FilterAll />
                </div>
                <AllAuctionListing proposed={0} viewed={0} />
              </div>
            </div>
          )}

          {activeTab == 'recentlyViewed' && (
            <div className="tab-pane active" id="recentlyViewed">
              <div className="row">
                <div className="col-lg-3 col-md-4">
                  <FilterAll />
                </div>
                <AllAuctionListing proposed={0} viewed={1} />
              </div>
            </div>
          )}

          {activeTab == 'savedContests' && (
            <div className="tab-pane active" id="allcontest">
              <div className="row">
                <div className="col-lg-3 col-md-4">
                  <FilterAll />
                </div>
                <AllAuctionListing proposed={0} viewed={0} saved={1} />
              </div>
            </div>
          )}


          {activeTab == 'myBids' && (
            <div className="tab-pane active" id="myBids">
              <div className="row">
                <div className="col-lg-3 col-md-4">
                  <FilterAll />
                </div>
                <AllAuctionListing proposed={1} viewed={0} />
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
